module.exports = __webpack_public_path__ + "static/media/node.ec1b5c55.svg";